// @flow

import ColorPalette from "./palette.json";

export default (color: string, variation: string) =>
  ColorPalette[color][variation].value;
